<div class="p-container p-5">
  <ng-container *ngIf="loading">
    <div class="text-center p-4">Loading assessment details...</div>
  </ng-container>

  <ng-container *ngIf="!loading && scoreHistoryData">
    <div class="grid md:grid-cols-12 grid-cols-1 gap-2">
      <div class="col-span-5">
        <main-assessment-score-card
          [score]="scoreHistoryData.latest_score"
          [progress]="scoreHistoryData.progress_from_last_assessment"
          [isPositive]="scoreHistoryData.is_positive"
          [date]="scoreHistoryData.date"
        >
        </main-assessment-score-card>
      </div>

      <div class="col-span-7">
        <patient-assessment-history-graph>

        </patient-assessment-history-graph>
      </div>
    </div>

    <div class="mt-8">
      <patient-assessment-history-list
        [history]="scoreHistoryData.pre_assessment_history"
        [assessmentDetails]="assessmentDetails"
      ></patient-assessment-history-list>
    </div>

   
  </ng-container>
</div>
